export const INTEGRATION_LOGO_ICON_CLASS = "size-10 object-contain";
export const INTEGRATION_LOGO_WORDMARK_CLASS =
	"h-4 w-auto max-w-[54px] object-contain";
